import { render, staticRenderFns } from "./pay-for.vue?vue&type=template&id=7dc7e095&"
import script from "./pay-for.vue?vue&type=script&lang=js&"
export * from "./pay-for.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports